import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeFooter() {
  return <>
      {/* Guarantee Section */}
      <section className="py-16 px-6 bg-brand-white" data-id="element-94">
        <div className="max-w-3xl mx-auto text-center" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex flex-col items-center gap-6" data-id="element-96">
            <div className="w-20 h-20 rounded-full bg-brand-cream flex items-center justify-center" data-id="element-97">
              <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-98" />
            </div>
            <p className="text-lg md:text-xl font-sans text-gray-700 leading-relaxed max-w-2xl" data-id="element-99">
              Acceso inmediato después del pago. Formato digital, sin envío. Si
              tenés algún problema con tu acceso, te respondemos en menos de 24
              horas.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 bg-[#1A0E1F] text-center" data-id="element-100">
        <p className="text-sm font-sans text-brand-white/40" data-id="element-101">
          © 2025 Gana con Conocimiento. Todos los derechos reservados.
        </p>
      </footer>
    </>;
}